/**
 * Сервис для работы с носимыми устройствами
 */

import axios, { AxiosRequestConfig } from 'axios';

import { IId } from '../models/types';
import { pageSize } from '../constants/pagination';
import { IGetViolationParams } from './ReportService';

export interface IGetAllParams {
  fullTextSearch?: string;
  pageIndex: number;
}

export interface IUpdateOrCreateBody {
  id: IId;
  number: string;
  classId: IId;
  model: string;
  invent: string;
  serial: string;
  mappingType: string;
  userId: IId | null | undefined;
  bestBefore: string | null;
}
const createCsvConfig = (filter: object): AxiosRequestConfig => ({
  params: { ...filter },
  responseType: 'blob'
});
const url = '/protection/wearable';

const DeviceService = {
  get: (id: IId) => axios.get(url, { params: { id } }),
  getAll: (params: IGetAllParams) => axios.get(`${url}s`, { params: { pageSize, ...params } }),
  updateOrCreate: (body: IUpdateOrCreateBody) => axios.post(`${url}`, body),
  unbind: (id: IId) => axios.post(`/protection/unbind?id=${id}`),
  delete: (id: IId) => axios.delete(url, { params: { id } }),
  getCsvDevices: (params: IGetViolationParams) =>
    axios.get(`v0/protection/wearables/export`, createCsvConfig(params))
};

export default DeviceService;
